export const register = {
  // Page header
  label: 'Join EachTeach',
  heading: 'Community Registration',
  intro:
    'Join the EachTeach community and let us raise the quality of education together.',

  // Success state
  successTitle: 'Registration complete!',
  successBody1: 'Thank you for joining the EachTeach community.',
  successBody2: 'We will send the details to the email address you provided.',

  // Form labels
  form: {
    name: 'Full Name',
    namePlaceholder: 'Taro Yamada',
    birthdate: 'Date of Birth',
    email: 'Email Address',
    emailPlaceholder: 'example@email.com',
    nationality: 'Nationality',
    nationalityPlaceholder: 'Japan',
    organization: 'Organization / Affiliation (optional)',
    organizationPlaceholder:
      'e.g. XX Language School (leave blank if individual)',
    languages: 'Languages You Can Teach',
    languagesOtherPlaceholder: 'Enter any other language',
    selected: 'Selected',
    category: 'Category',
    categorySelect: 'Please select',
    consent:
      'I consent to having my organization / affiliation listed on the EachTeach introduction page (optional).',
    consentNote:
      'Even with your consent, listing is done after content review. You can register without consenting.',
    requiredMark: '*',
    submit: 'Register',
    submitting: 'Submitting...',
  },

  // Category options
  categories: {
    tutor: 'Individual Tutor',
    aspiring: 'Aspiring Individual Tutor',
    sla: 'SLA Field Expert',
  },

  // Language options
  languages: {
    japanese: 'Japanese',
    english: 'English',
    chineseMandarin: 'Chinese (Mandarin)',
    chineseCantonese: 'Chinese (Cantonese)',
    korean: 'Korean',
    spanish: 'Spanish',
    french: 'French',
    german: 'German',
    portuguese: 'Portuguese',
    italian: 'Italian',
    russian: 'Russian',
    arabic: 'Arabic',
    hindi: 'Hindi',
    turkish: 'Turkish',
    other: 'Other',
  },

  // Error / validation messages
  errors: {
    saveFailed: 'Failed to save your registration. Please try again later.',
    submitFailed: 'An error occurred while submitting. Please try again.',
  },
};
